import styled from 'styled-components';

const BasicDivPdTBBlock = styled.div`
  padding: 20px 0;
`;

export default BasicDivPdTBBlock;
